// Select option lists. Reuses the existing KYC constant data + PSGC location
// lists so the wizard stays consistent with the rest of the app.
import {
  natureOfBusinessList,
  optionSelectedAnnualIncome,
} from "@/components/kyc/LongKYC/constants";
import {
  optionCivilStatus,
  optionGender,
  optionNationality,
  optionSuffix,
  shortOccupation,
  sourceIncome,
} from "@/components/kyc/shortKYC/constants";
import COUNTRIES from "@/components/PRPCM/Countries";
import IDTYPE from "@/components/PRPCM/IdTypes";

export interface SelectItem {
  label: string;
  value: string | number | boolean;
}

interface NameValueOptions {
  name?: Array<string | number>;
  value?: Array<string | number>;
}

function toSelectItems(options: NameValueOptions): SelectItem[] {
  return (options.name || []).map((label, index) => ({
    label: String(label),
    value: options.value?.[index] ?? label,
  }));
}

export const occupationItems = toSelectItems(shortOccupation);
export const natureOfBusinessItems = toSelectItems(natureOfBusinessList);
export const annualIncomeItems = toSelectItems(optionSelectedAnnualIncome);
export const sourceOfFundsItems = toSelectItems(sourceIncome);
export const suffixItems = toSelectItems(optionSuffix);
export const nationalityItems = toSelectItems(optionNationality);
export const genderItems = toSelectItems(optionGender);
export const civilStatusItems = toSelectItems(optionCivilStatus);
export const idTypeItems: SelectItem[] = (IDTYPE as Array<{ name: string }>).map(
  (item) => ({ label: item.name, value: item.name })
);

export const countryItems: SelectItem[] = (
  COUNTRIES as Array<{ name: string }>
).map((item) => ({ label: item.name, value: item.name }));

export const accountTypeItems: SelectItem[] = [
  { label: "Current Account", value: false },
  { label: "Savings Account", value: true },
];

export const yesNoItems: SelectItem[] = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

export const bankItems: SelectItem[] = [
  "ALLBANK (A THRIFT BANK), INC.",
  "ASIA UNITED BANK",
  "BPI / VYBE BY BPI",
  "BDO NETWORK BANK, INC.",
  "BANGKO MABUHAY (A RURAL BANK), INC.",
  "BPI DIRECT BANKO, INC., A SAVINGS BANK",
  "BANANA FINTECH / BANANAPAY",
  "BANCO DE ORO",
  "BANK OF COMMERCE",
  "BANK OF CHINA",
  "BANK OF THE PHIL. ISLANDS",
  "CARD SME BANK",
  "CHINA BANKING CORPORATION",
  "CIS BAYAD CENTER, INC.",
  "CARD BANK, INC.",
  "COMMUNITY RURAL BANK OF ROMBLON (ROMBLON), INC.",
  "CIMB PHILIPPINES INC",
  "CHINA BANK SAVINGS INC.",
  "CAMALIG BANK",
  "CITY SAVINGS BANK, INC.",
  "CARD MRI",
  "CTBC BANK (PHILIPPINES) CORPORATION",
  "CANTILAN BANK, INC.",
  "DEVELOPMENT BANK OF THE PHILS.",
  "DUMAGUETE CITY DEVELOPMENT BANK, INC.",
  "DUNGGANUN BANK INC.",
  "EASTWEST RURAL BANK",
  "EAST WEST BANK",
  "ENTREPRENEUR RURAL BANK, INC./ENTRP",
  "EQUICOM SAVINGS BANK",
  "GOTYME BANK",
  "INFOSERVE / NATIONLINK",
  "ISLA BANK INC.",
  "LULU FINANCIAL SERVICES (PHILS), INC.",
  "LAND BANK OF THE PHILS.",
  "LEGAZPI SAVINGS BANK",
  "MALAYAN BANK",
  "MAYBANK PHILS. INC.",
  "MINDANAO CONSOLIDATED COOPBANK",
  "METROBANK",
  "NETBANK",
  "OMNIPAY",
  "OWN BANK",
  "PHIL. TRUST COMPANY",
  "PHIL. BANK OF COMMUNICATION",
  "PRODUCERS BANK",
  "PARTNER RURAL BANK",
  "PHIL. SAVINGS BANK",
  "PHILIPPINE DIGITAL ASSET EXCHANGE, INC. / PDAX",
  "PHIL. VETERANS BANK",
  "PACIFIC ACE SAVINGS BANK",
  "PAYMONGO PAYMENTS, INC.",
  "PHIL. NATIONAL BANK",
  "PHIL. BUSINESS BANK",
  "QUEZON CAPITAL RURAL BANK INC.",
  "QUEEN CITY DEVELOPMENT BANK",
  "RURAL BANK OF GUINOBATAN, INC.",
  "RIZAL COMML. BANKING CORPORATION",
  "ROBINSON BANK CORPORATION",
  "STARPAY",
  "SECURITY BANK CORPORATION 2",
  "SECURITY BANK AND TRUST COMPANY",
  "SUN SAVING BANK INC.",
  "STANDARD CHARTERED BANK",
  "STERLING BANK OF ASIA",
  "SEABANK/MARIBANK",
  "TONIK BANK",
  "TRAXIONPAY/DIGICOOP/COOPNET",
  "TAYOCASH",
  "UNIONBANK OF THE PHILIPPINES",
  "UCPB SAVINGS BANK",
  "USSC MONEY SERVICES",
  "UNOBANK",
  "UNION DIGITAL",
  "VIGAN BANCO RURAL INCORPORADA",
  "WEALTH DEVELOPMENT BANK",
].map((bank) => ({ label: bank, value: bank }));
